import { useEffect } from 'react';

const useHotjar = () => {
    useEffect(() => {
        if (window.hj) return;

        if (import.meta.env.VITE_APP_ENV !== 'production') return;

        const hotjarScriptUrl = 'https://static.hotjar.com/c/hotjar-5363050.js?sv=6';

        (function () {
            window.hj =
                window.hj ||
                function () {
                    (window.hj.q = window.hj.q || []).push(arguments);
                };
            window._hjSettings = { hjid: 5363050, hjsv: 6 };

            const head = document.getElementsByTagName('head')[0];
            const script = document.createElement('script');
            script.async = true;
            script.src = hotjarScriptUrl;

            head.appendChild(script);
        })();
    }, []);
};

export default useHotjar;
